import { CardTypeConfig } from '../../interfaces/card-type-config';

export const CONECS_CARD_TYPE_NAME = 'conecs';

export const CONECS_CARD_TYPE_CONFIG: CardTypeConfig = {
    niceType: 'Conecs',
    type: CONECS_CARD_TYPE_NAME,
    patterns: [
        48384500,
        48384501,
        48384502,
        507596,
        507599,
        50759700,
        50759701,
        519303,
        532041
    ],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
        name: 'CVV',
        size: 3
    }
};
